import metadataService from "@/services/metadataService";
import { useQuery } from "@tanstack/react-query";

export const metadataKeys = {
  global: ["metadata", "global"] as const,
  countries: ["metadata", "countries"] as const,
};

export const useMetadata = () => {
  return useQuery({
    queryKey: metadataKeys.global,
    queryFn: () => metadataService.getMetadata(),
    staleTime: Infinity,
  });
};

export const useCountries = () => {
  return useQuery({
    queryKey: metadataKeys.countries,
    queryFn: () => metadataService.getCountries(),
    staleTime: Infinity,
  });
};
